import { DebtCollectionSupplierKind } from './const/enums';

export class DebtCollectionConfiguration {
  enabled: boolean;
  userName: string;
  password: string;
  client: string;
  division: string;
  ropo24Enabled: boolean;
  debtCollectionSupplier: DebtCollectionSupplierKind;
}
